import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { CatPromotion } from 'src/app/model/promotion-models';
import { CommissionPromotionsService } from 'src/app/services/commission-promotions.service';
import { ModalConfigPromotionComponent } from 'src/app/shared/modal-config-promotion/modal-config-promotion.component';

@Component({
  selector: "app-commission-config-promotions",
  templateUrl: "./commission-config-promotions.component.html",
  styleUrls: ["./commission-config-promotions.component.css"],
})
export class CommissionConfigPromotionsComponent implements OnInit {
  // estado pagina
  public viewStatus = 0; // -1:nada, 0:spinner, 1:tabla
  public listPromotions: CatPromotion[] = [];

  // opciones datatables
  dtOptions = {
    order: [],
    responsive: true,
    columnDefs: [
      { responsivePriority: 1, width: 100, targets: -1 },
      { responsivePriority: 2, width: 100, targets: -2 },
    ],
    select: "single",
    bLengthChange: true,
    searching: true,
    dom: '<"row"<"col"l><"col"<"text-center"B>><"col"f>><"row"<"col"t>><"row"<"col"i><"col"p>>',
    buttons: ["csv", "excel"],
    autoWidth: false,
    paging: true,
    pageLength: 25,
    language: {
      processing: "Procesando...",
      search: "Buscar:",
      lengthMenu: "Mostrar _MENU_ elementos",
      info: "Mostrando del _START_ al _END_ de _TOTAL_ elementos",
      infoEmpty: "Mostrando ningún elemento.",
      infoFiltered: "(filtrado _MAX_ elementos total)",
      infoPostFix: "",
      loadingRecords: "Cargando registros...",
      zeroRecords: "No se encontraron registros",
      emptyTable: "No hay datos disponibles en la tabla",
      paginate: {
        first: "Primero",
        previous: "Anterior",
        next: "Siguiente",
        last: "Último",
      },
      aria: {
        sortAscending: ": Activar para ordenar la tabla en orden ascendente",
        sortDescending: ": Activar para ordenar la tabla en orden descendente",
      },
    },
  };

  /////////////////
  constructor(
    private commissionPromotionsService: CommissionPromotionsService,
    private modalService: NgbModal,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    // this.getCatalogs();
  }

  add = () => {
    let modalRef = this.modalService.open(ModalConfigPromotionComponent, {
      centered: true,
      size: "lg",
      scrollable: true,
      backdrop: "static",
      keyboard: false,
    });
    modalRef.componentInstance.mode = "add";
    modalRef.result.then(
      (data) => console.log(data),
      (reason) => {
        console.log(reason);
        if (reason !== "cancel") {
          this.viewStatus = 0;
          // this.getCatalogs();
        }
      }
    );
  };

  edit = (item: CatPromotion) => {
    let modalRef = this.modalService.open(ModalConfigPromotionComponent, {
      centered: true,
      size: "lg",
      scrollable: true,
      backdrop: "static",
      keyboard: false,
    });
    modalRef.componentInstance.mode = "edit";
    modalRef.componentInstance.promotionId = item.catPromotionId;
    modalRef.result.then(
      (data) => {
        console.log(data);
      },
      (reason) => {
        console.log(reason);
        if (reason !== "cancel") {
          this.viewStatus = 0;
          // this.getCatalogs();
        }
      }
    );
  };

  consult = (item: CatPromotion) => {
    let modalRef = this.modalService.open(ModalConfigPromotionComponent, {
      centered: true,
      size: "lg",
      scrollable: true,
      backdrop: "static",
      keyboard: false,
    });
    modalRef.componentInstance.mode = "consult";
    modalRef.componentInstance.promotionId = item.catPromotionId;
    modalRef.result.then(
      (data) => {
        console.log(data);
      },
      (reason) => {
        console.log(reason);
        if (reason !== "cancel") {
          this.viewStatus = 0;
          // this.getCatalogs();
        }
      }
    );
  };

  // INFO
  // getCatalogs = () => {
  //   this.commissionPromotionsService.getAllPromotions().subscribe(
  //     (resp) => {
  //       console.log(resp);
  //       this.listPromotions = resp.data;
  //       this.viewStatus = 1;
  //     },
  //     (error) => {
  //       console.log(error);
  //       this.viewStatus = -1;
  //       this.toastr.error("Ocurrió un error al obtener la información");
  //     }
  //   );
  // };

  // toggleActivePromotion = (catPromotion: CatPromotion) => {
  //   this.commissionPromotionsService
  //     .toggleActivePromotion(catPromotion)
  //     .subscribe(
  //       (resp) => {
  //         console.log(resp);
  //         if (resp.httpStatusCode == 200) {
  //           catPromotion.activeId = resp.data.activeId == true;
  //           this.toastr.info(
  //             "Se ha cambiado el estado de la promoción " +
  //             catPromotion.promotionName +
  //             " y ahora esta en status: " +
  //             (catPromotion.activeId == true ? "Activo" : "Inactivo")
  //           );
  //         } else {
  //           this.toastr.error(
  //             "Ocrurrio algun error y no se logro activar/desactivar la promoción"
  //           );
  //         }
  //       },
  //       (error) => {
  //         console.log(error);
  //         this.toastr.error(
  //           "Ocrurrio algun error, no se logro activar/desactivar la promoción"
  //         );
  //       }
  //     );
  // };

  promotionIsActive(promotion: CatPromotion) {
    return (
      promotion.activeId &&
      Date.parse(promotion.effectiveDate) >= Date.now() &&
      Date.parse(promotion.effectiveSince) <= Date.now()
    );
  }

  activeStatus(promotion: CatPromotion) {
    let status = promotion.activeId ? 1 : -1;
    if (status == 1) {
      status =
        Date.parse(promotion.effectiveDate) >= Date.now() &&
          Date.parse(promotion.effectiveSince) <= Date.now()
          ? 1
          : 0;
    }
    return status;
  }

  // clonePromotion(catPromotion: CatPromotion) {
  //   this.viewStatus = 0;
  //   this.commissionPromotionsService
  //     .savePromotionConfigClone(catPromotion)
  //     .subscribe(
  //       (resp) => {
  //         console.log(resp);
  //         this.toastr.info(
  //           "La promoción se clono correctamente, ID: " +
  //           resp.data.catPromotionId
  //         );
  //         this.listPromotions.push(resp.data);
  //         this.listPromotions.sort((a, b) => Date.parse(b.effectiveDate) - Date.parse(a.effectiveDate));
  //         this.viewStatus = 1;
  //       },
  //       (error) => {
  //         console.log(error);
  //         this.toastr.error(
  //           "Ocurrio algún error al intentar clonar la promoción"
  //         );
  //         this.viewStatus = 1;
  //       }
  //     );
  // }
}
